import { assert } from '@ember/debug';
import { DEBUG } from '@glimmer/env';
import WeakCache from './weak-cache';

/*
 * Returns the RecordData instance associated with a given
 * Model or InternalModel.
 *
 * Intentionally "loose" to allow anything with an _internalModel
 * property until InternalModel is eliminated.
 *
 * Intentionally not typed to `InternalModel` due to circular dependency
 *  which that creates.
 *
 * Overtime, this should shift to a "weakmap" based lookup in the
 *  "Ember.getOwner(obj)" style.
 */

const RecordDataForIdentifierCache = new WeakCache(DEBUG ? 'recordData' : '');
export function setRecordDataFor(identifier, recordData) {
  assert(`Illegal set of identifier`, !RecordDataForIdentifierCache.has(identifier));
  RecordDataForIdentifierCache.set(identifier, recordData);
}
export function removeRecordDataFor(identifier) {
  RecordDataForIdentifierCache.delete(identifier);
}
export default function recordDataFor(instance) {
  if (RecordDataForIdentifierCache.has(instance)) {
    return RecordDataForIdentifierCache.get(instance);
  }
  let internalModel = instance._internalModel || instance.internalModel || instance;
  return internalModel._recordData || null;
}